module.exports = __webpack_public_path__ + "img/IE.0980670c.png";